import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import AddIcon from '@mui/icons-material/Add';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import { Translate } from '../../../../../../../shared/LanguageService';
import { ExpandingButton } from '../../../shared/selection/view/ExpandingButton';


type StitchImagesButtonProps = {
    isStitching: boolean;
    isStitchReady: boolean;
    onStitchToggle: () => void;
    onStitchCancel: () => void;
};

export function StitchImagesButton({
    isStitching,
    isStitchReady,
    onStitchToggle,
    onStitchCancel
}: StitchImagesButtonProps) {
    return (
        <Box
            component="nav"
            role="toolbar"
            aria-label="Post-approval image actions"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}
        >
            <ExpandingButton
                variant="contained"
                type="submit"
                disabled={!isStitchReady}
                data-visible={isStitching}
                aria-hidden={!isStitching}
                tabIndex={isStitching ? 0 : -1}
                sx={{
                    transitionDelay: isStitching ? '50ms' : '0ms',
                    backgroundColor: 'primary.main',
                    '&:hover': {
                        backgroundColor: 'primary.dark'
                    }
                }}
            >
                {Translate('image-processing/button-label/stitch-images')}
            </ExpandingButton>

            <Tooltip
                placement="top"
                title={isStitching ? '' : Translate('image-processing/button-label/stitch-images')}
            >
                <span>
                    <Button
                        variant="outlined"
                        onClick={onStitchToggle}
                        disabled={isStitching}
                        sx={{
                            minWidth: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '2px',
                            px: 1.5
                        }}
                    >
                        <LooksOneIcon fontSize="small" />
                        <AddIcon fontSize="small" />
                        <LooksTwoIcon fontSize="small" />
                    </Button>
                </span>
            </Tooltip>

            <ExpandingButton
                variant="outlined"
                startIcon={<CloseIcon />}
                data-visible={isStitching}
                aria-hidden={!isStitching}
                tabIndex={isStitching ? 0 : -1}
                onClick={onStitchCancel}
                sx={{ transitionDelay: isStitching ? '50ms' : '0ms' }}
            >
                {Translate('image-processing/button-label/select-many/disable')}
            </ExpandingButton>
        </Box>
    );
}
